import { declareEntity } from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';

export const LOG_TYPE_COMMUNICATION = 'communication';
export const LOG_TYPE_ORGANISATION_BLOCKED = 'organisationBlocked';
export const LOG_TYPE_FULLY_PAID = 'fullyPaid';
export const LOG_TYPE_PARTIALLY_PAID = 'partiallyPaid';
export const LOG_TYPE_MARK_AS_IGNORED = 'markAsIgnored';
export const LOG_TYPE_ORGANISATION_UNBLOCKED = 'organisationUnblocked';
export const LOG_TYPE_BILL_UPDATED = 'billUpdated';
export const LOG_TYPE_BILL_CREATED = 'billCreated';
export const LOG_TYPE_OTHER = 'other';
const logTypes = {
	[LOG_TYPE_COMMUNICATION]: {
		name: "Komunikace",
		description: "Záznam o komunikaci s organizací ohledně dluhu",
	},
	[LOG_TYPE_ORGANISATION_BLOCKED]: {
		name: "Organizace zablokována",
		description: "Záznam o zablokování organizace kvůli dluhu",
	},
	[LOG_TYPE_FULLY_PAID]: {
		name: "Úplně zaplaceno",
		description: "Záznam o úplném zaplacení dluhu organizací",
	},
	[LOG_TYPE_PARTIALLY_PAID]: {
		name: "Částečně zaplaceno",
		description: "Záznam o částečném zaplacení dluhu organizací",
	},
	[LOG_TYPE_MARK_AS_IGNORED]: {
		name: "Označeno jako ignorováno",
		description: "Záznam o označení dluhu jako ignorovaného",
	},
	[LOG_TYPE_ORGANISATION_UNBLOCKED]: {
		name: "Organizace odblokována",
		description: "Záznam o odblokování organizace po vyřešení dluhu",
	},
	[LOG_TYPE_BILL_UPDATED]: {
		name: "Záznam aktualizován",
		description: "Záznam o aktualizaci informací o dluhu organizace",
	},
	[LOG_TYPE_BILL_CREATED]: {
		name: "Záznam vytvořen",
		description: "Záznam o vytvoření nového dluhu organizace",
	},
	[LOG_TYPE_OTHER]: {
		name: "Jiné",
		description: "Jiný typ záznamu",
		default: true,
	}
};


export default declareEntity({
	name: "OrganisationOverdueBillLog",
	entity: "organisationOverdueBillLogs",
	graphQL: "OrganisationOverdueBillLog",
	dynamoPrefix: 'org',
	storageType: 'central',
	defaultTitle: (data) => data['title'] || "",
	fields: (types) => ({
		id: {
			type: "id",
			defaultValue: () => uuidv4(),
			primaryKey: true,
			required: true,
			userEditable: false,
		},
		organisationOverdueBill: {
			name: "Overdue Bill",
			type: "relation",
			to: () => types['organisationOverdueBills'],
			required: true,
			userEditable: false,
		},
		timestamp: {
			type: "datetime",
			required: true,
			userEditable: false,
			description: "Timestamp of the log entry",
			defaultValue: () => new Date().toISOString(),
		},
		title: {
			type: "string",
			required: false,
			userEditable: true,
			description: "Title of the log entry"
		},
		message: {
			type: "string",
			required: false,
			userEditable: true,
			description: "Log message"
		},
		type: {
			type: "enum",
			values: logTypes,
			required: true,
			userEditable: true,
			description: "Action taken (e.g. 'notified', 'blocked', 'paid')",
			defaultValue: LOG_TYPE_OTHER,
		},
		createdAt: {
			type: "datetime",
			defaultValue: () => new Date(),
			userEditable: false,
		},
		communication: {
			type: "relation",
			to: () => types['organisationOverdueBillCommunications'],
			required: false,
			userEditable: false,
		},
		blocked_organisation: {
			type: "relation",
			to: () => types['organisations'],
			required: false,
			userEditable: false,
		},
	}),
	relations: (types) => ({
		action: {
			type: "manyToOne",
			to: types['organisationOverdueBillActions'],
			required: false,
			userEditable: false,
			foreignKeys: [
				{ from: "id", to: "organisationOverdueBillLog_id" }
			]
		}
	}),
});


